import styled, { css } from "styled-components";

export default {
    "Wrapper": styled.div`
        display: flex;
        flex-direction: column;
        align-items: center;
        gap: 40px;
        padding: 40px;
        background-color: ${({ theme }) => theme.color.white};
        border-radius: 16px;
    `,
    "AreaDiv": styled.div`
        display: flex;
        flex-direction: column;
        align-items: center;
        gap: 16px;

        & > h2 {
            ${({ theme }) => theme.font.small_bold};
        }
    `,
    "LogoImg": styled.img`
        height: 180px;
    `,

    "Tab": styled.button`
        ${({ theme }) => theme.font.small_bold};

        ${({ $selected }) => $selected && css`
            ${({ theme }) => theme.font.small_bold};
            color: ${({ theme }) => theme.color.major};
        `}  
    `,
    "Radio": styled.button`
        display: flex;
        align-items: center;
        gap: 8px;
    `,
      "InputWrapper": styled.div`
            height: 40px;
            display: flex;
            gap: 8px;
    
            & > input {
                width: 100%;
                ${({ theme }) => theme.font.extra_small};
                padding: 0 20px;
                border: 1px solid ${({ theme }) => theme.color.grey3};
                border-radius: 4px;
            }
        `
}